import * as L from "leaflet";
import {GestureHandling} from "leaflet-gesture-handling";
import "leaflet/dist/leaflet.css";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";

const baseURL = "./rest/"

export const lookupURL = baseURL + "lookup/"
export const municipalityURL = baseURL + "swisstopo/municipality/"
export const heightURL = baseURL + "swisstopo/height/"
export const taxonByIdURL = lookupURL + "taxonById"
export const taxonByNameURL = lookupURL + "taxonByName"

export const saveRecordURL = baseURL + 'fungus/record'
export const updateRecordURL = baseURL + 'fungus/record'
export const validateRecordURL = baseURL + 'fungus/expert_validation'

export const getRecordByIdURL = baseURL + 'fungus/record/byId'
export const getUserRecordsURL = baseURL + 'fungus/record/byFinder'
export const getAllUserRecordsURL = baseURL + 'fungus/record/all'
export const getUserRecordsValidationURL = baseURL + 'fungus/record/validation'
export const deleteRecordURL = baseURL + 'fungus/record/delete'

export const userLoginURL = baseURL + 'user/pub/login'
export const userUpdatePwURL = baseURL + 'user/updatepw'
export const userUpdateURL = baseURL + 'user/update'
export const userSignupURL = baseURL + 'user/pub/signup'
export const userResetPwURL = baseURL + 'user/pub/resetpw'
export const userResetPwTokenURL = baseURL + 'user/pub/resetpwtoken'
export const checkUserAdminRoleURL = baseURL + 'user/pub/isadmin'

export const tokenLifetime = 86400000

export function scrollToTop() {
    window.scrollTo(0, 0);
}

export function mapConfig(element: string) {
    const baseLayer = L.tileLayer('https://wmts20.geo.admin.ch/1.0.0/ch.swisstopo.pixelkarte-farbe/default/current/3857/{z}/{x}/{y}.jpeg',
        {
            attribution:
                '<a href="https://www.geo.admin.ch/" target="_blank">geo.admin.ch</a>',
            minZoom: 7.5,
            bounds: L.latLngBounds(L.latLng(45, 6), L.latLng(48, 10)),
        })

    const swissImageLayer = L.tileLayer('https://wmts20.geo.admin.ch/1.0.0/ch.swisstopo.swissimage-product/default/current/3857/{z}/{x}/{y}.jpeg',
        {
            attribution:
                '<a href="https://www.geo.admin.ch/" target="_blank">geo.admin.ch</a>',
            minZoom: 7.5,
            bounds: L.latLngBounds(L.latLng(45, 6), L.latLng(48, 10)),
        })

    L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);
    // @ts-ignore
    const map = L.map(element, {layers: [baseLayer], gestureHandling: true})
    // force Leaflet caption to open in new window to avoid losing data in form
    map.attributionControl.setPrefix('<a href="http://leafletjs.com" title="A JS library for interactive maps" target="_blank">Leaflet</a>');

    // @ts-ignore
    L.control.layers({"Landeskarte": baseLayer}, {"Luftbild": swissImageLayer}).addTo(map);

    map.setView(L.latLng(46.77591, 8.3), 7.5)

    // add metric scaled and disable imperial scale line (mi/ft)
    // @ts-ignore
    L.control.scale({imperial: false}).addTo(map)
    return map
}

export const defaultHeadersUserRecords = [
    {name: 'table.RECORD_ID', header: "RECORD_ID"},
    {name: 'table.RECORD_DATE', header: "RECORD_DATE"},
    {name: 'table.TAXON_NAME', header: "TAXON_NAME"}
]

export const defaultHeadersExpertValidation = [
    {name: 'table.RECORD_ID', header: "RECORD_ID"},
    {name: 'table.RECORD_DATE', header: "RECORD_DATE"},
    {name: 'table.TAXON_NAME', header: "TAXON_NAME"},
    {name: 'table.PRESENCE', header: "PRESENCE"},
]
